import { Loader, getDateTimeFormat, CustomModal } from '@nile/components';
import { getDayDetails } from '@nile/mangifera/src/Pebbles/Calendar';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  DateTimePicker,
  TextStyle,
  ToggleButton
} from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import EventCalendar from './EventCalendar';
import { useLazyQuery } from '@apollo/client';
import { GET_CALENDAR_EVENTS } from '@nile/graphql';

const CALENDAR_VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};
const SheetStyles = styled.div`
  width: 500px;
  background: white;
  height: 100vh;
  .Header {
    padding: 18px 20px;
    position: relative;
    border-bottom: 1px solid #dfdfdf;
    margin-bottom: 10px;
    position: relative;
    .event-calendar-close-icon {
      position: absolute;
      right: 0;
      top: 10px;
    }
  }

  .Calender-wrapper {
    height: calc(100vh - 200px);
    overflow: auto;
  }
`;

const CalenderSheetHeader = (props) => {
  const date = props?.day?.date;
  const shortDate = props?.day?.number;
  const shortDay = props?.day?.shortDay;
  const month = props?.day?.longMonth;
  const year = props?.day?.year;

  const onDayChange = (date) => {
    props?.onDayChange(date);
  };

  const togglePreviousDay = () => {
    let day = new Date(date);
    let prevDay = new Date(day);
    prevDay.setDate(day.getUTCDate() - 1);
    props?.onDayChange(prevDay);
  };

  const toggleNextDay = () => {
    let day = new Date(date);
    let nextDay = new Date(day);
    nextDay.setDate(day.getUTCDate() + 1);
    props?.onDayChange(nextDay);
  };

  return (
    <div className="relative">
      {props?.disableCalendar ? (
        <div className="flex g5 actr ">
          <div className="pt-5">
            <SVGIcon name="DatePicker" />
          </div>
          <TextStyle>
            {month} {year}
          </TextStyle>
        </div>
      ) : (
        <DateTimePicker
          dateFormat={getDateTimeFormat().dateFormat}
          onChange={(date) => {
            onDayChange(date);
          }}
          selected={new Date(date)}
          customInput={
            <Button plain icon={<SVGIcon name="DatePicker" color="#011FFF" />}>
              <div className="flex g5 actr">
                <div>
                  {month} {year}
                </div>
                <div>
                  <SVGIcon name="ArrowDown" color="#011FFF" />
                </div>
              </div>
            </Button>
          }
          popperPlacement="bottom-start"
        />
      )}

      <div className="flex fx-sb align-items-end">
        <div className="flex g10 mt10 actr">
          <div>
            <TextStyle weight="SemiBold">
              <span className="f-20">
                {shortDay} {shortDate}
              </span>
            </TextStyle>
          </div>

          {!props?.hideButtons && (
            <div className="arrows flex g20">
              <div>
                <Button
                  icon={<SVGIcon name="ArrowLeft" />}
                  onClick={togglePreviousDay}
                />
              </div>
              <div>
                <Button
                  icon={<SVGIcon name="ArrowRight" />}
                  onClick={toggleNextDay}
                />
              </div>
            </div>
          )}
        </div>

        {props?.showToggle && (
          <div className="flex actr g10 ">
            {props?.toggleLabel && (
              <div>
                <TextStyle variation="subdued">{props?.toggleLabel}</TextStyle>
              </div>
            )}

            <div>
              <ToggleButton
                size="small"
                value={props?.toggleState}
                onChange={(val) => props?.onToggle(val)}
              />
            </div>
          </div>
        )}
      </div>

      <div
        className="event-calendar-close-icon pointer"
        onClick={props?.onClose}
      >
        <SVGIcon name="Close" />
      </div>
    </div>
  );
};

const CalendarSheet = (props) => {
  const [day, setDay] = useState(props?.day);
  const [date, setDate] = useState(props?.date);
  const [events, setEvents] = useState(props?.events || []);
  const [loading, setLoading] = useState(false);
  const [backgroundEvents, setBackgroundEvents] = useState(
    props?.backgroundEvents || []
  );

  useEffect(() => {
    setDate(props?.date);
    setEvents(props?.events);
    setBackgroundEvents(props?.backgroundEvents);
  }, [props?.events, props?.date, props?.backgroundEvents]);

  const resizeEvent = (data) => {
    if (props?.onEventResize) {
      props?.onEventResize(data);
    }
  };

  const eventDrop = (data) => {
    if (props?.onEventDrop) {
      props?.onEventDrop(data);
    }
  };

  return (
    <CustomModal
      open={props?.sheetActive}
      onClose={props.onClose}
      className={`custom-calendar-sheet ${props?.className}`}
      locked
      zIndex={props?.zIndex}
    >
      <SheetStyles>
        <div className="Header">
          <CalenderSheetHeader
            day={props?.day}
            date={props?.date}
            // focusBusinessHour={props?.focusBusinessHour}
            // startHour={props?.startHour}
            onDayChange={props?.onDayChange}
            onClose={props.onClose}
            showToggle={props?.showToggle}
            toggleState={props?.toggleState}
            onToggle={props?.onToggle}
            toggleLabel={props?.toggleLabel}
            hideButtons={props?.hideButtons}
            disableCalendar={props?.disableCalendar}
          />
        </div>

        <div className="Calender-wrapper">
          {loading || props?.loading ? (
            <>
              <Loader />
            </>
          ) : (
            <EventCalendar
              defaultDate={date} // Need to pass
              defaultView={CALENDAR_VIEWS.DAY}
              events={events || []}
              backgroundEvents={backgroundEvents || []}
              onEventResize={resizeEvent}
              onEventDrop={eventDrop}
              components={props?.components}
              enableDragAndDrop={props?.enableDragAndDrop || false}
              step={props?.step || 30}
              timeslots={props?.timeslots}
              onSelecting={props?.onSelecting || null}
            />
          )}
        </div>
      </SheetStyles>
    </CustomModal>
  );
};

export default CalendarSheet;
